import {redirect} from 'react-router-dom';

export default function Logout() {
	return (
		<div>Logout</div>
	);
}

export function logoutLoader() {
	localStorage.removeItem('isLogin');
	localStorage.removeItem('rezvan_token');
	return redirect('/');
}
